import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const SETTINGS_ACTIONS_ID = 'settings-header-actions'

/**
 * Кнопка действия вкладки настроек («Добавить компанию», «Добавить точку»...)
 * выводится в шапку рядом с заголовком «Настройки», а не прячется под строкой
 * вкладок - так же, как кнопки в «Парке» и «Курьерах».
 *
 * Сама страница вкладки знает, что и как добавлять, поэтому кнопку рисует
 * она, а сюда она переносится порталом в слот, который держит SettingsLayout.
 */
const SettingsHeaderAction = ({ children }) => {
  const [slot, setSlot] = useState(null)

  useEffect(() => {
    setSlot(document.getElementById(SETTINGS_ACTIONS_ID))
  }, [])

  return slot ? createPortal(children, slot) : null
}

export default SettingsHeaderAction
